import TableHead from './TableHead';
export * from './TableHead';
export default TableHead;
